import React, { Component } from 'react';
import config from 'react-global-configuration';
import getLocale from '../../../i18n/getLocale';
import RequestApi from '../../Miscelania/RequestApi';

class StaffCertificationAddFile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      id: this.props.staff_certification_id,
      file_archived: this.props.file_archived,
      file: this.props.file,
    };

    this.locale = getLocale();

    //bind específico
    this.addFile = this.addFile.bind(this);
    this.export = this.export.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.staff_certification_id !== 'undefined') {
      this.setState({
        id: newProps.staff_certification_id,
        file_archived: newProps.file_archived,
        file: newProps.file,
      });
    }
  }

  addFile(event) {
    event.preventDefault();
    var confirm = window.confirm(this.locale.Tripulantes.EditarFuncionario.tabCertificacoes.temCertezaQueGostariaDeImportarEsteArquivo);
    if (confirm) {
      var data = new FormData();
      var imagedata = document.querySelector('.input-archive-staff-certification-' + this.state.id).files[0];
      data.append("imagem", imagedata);
      data.append("id", this.state.id);
      var header = this.refs.request_api.header();
      var self = this;
      this.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/certificado/arquivo', {
          method: 'POST',
          mode: 'cors',
          headers: value,
          body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            if (responseJson.status === 'success') {
              self.props.refreshData();
            }
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch((error) => {
          console.error(error);
        });
      });
    }
  }


  export(event) {
    event.preventDefault();
    var self = this;
    var url = '/exportar/certificado/funcionario/';
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.state.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      });
    });
  }


  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
    <form onSubmit={this.addFile}>
        <input type="text" type="file" name="archive" className={"form-control input-display-inline input-archive-staff-certification-" + this.state.id} placeholder={this.locale.Tripulantes.EditarFuncionario.tabCertificacoes.formularioAdicionarArquivo.placeholder.Arquivo} value={this.state.archive} onChange={this.handleChange.bind(this, 'archive')} style={{width: 135}} />
        <button type="submit" className="btn btn-primary btn-sm btn-margin-bottom btn-margin-left"><i className="fa fa-save"></i></button>
        &nbsp;
        <a className={"btn btn-sm btn-warning btn-margin-bottom"} disabled={this.state.file_archived === 1 ? "" : "disabled"} target="_blank" href={config.get('cdn') + '/files/certifications/' + this.state.file}><i className="fa fa-fw fa-download"></i>
        </a>
        &nbsp;
        <button type="button" className={"btn btn-sm btn-success btn-margin-bottom"} onClick={this.export}><i className="fa fa-fw fa-file-o"></i></button>
    </form>
</div>
    );
  }
}

export default StaffCertificationAddFile;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffCertificationAddFile.js